// extracted by mini-css-extract-plugin
export default {"wrapper":"ExtensionWallet_wrapper__VbI1T","textWrapper":"ExtensionWallet_textWrapper__QuMXO","img":"ExtensionWallet_img__QLlAM"};